import { FlowComponentProps } from 'components/generics/flows/Flow';
import LoginSignupCodeVerify from 'components/generics/flows/LoginSignUpFlow/SharedComponents/LoginSignupCodeVerify';
import classes from 'components/generics/flows/LoginSignUpFlow/SignUpFlow/components/SignUpVerify/index.module.scss';
import { useSignUp } from 'components/generics/flows/LoginSignUpFlow/SignUpFlow/context';
import { SIGN_UP_PROCESS_COMPLETE } from 'consts/analytics/onBoardingEvents';
import { analytics } from 'hooks/integrations/mixpanel/useMixpanel';
import { updateUserDetails } from 'hooks/requests/user/requests/UpdateUserDetails';
import BackButtonIcon from 'public/assets/icons/chevron_left.svg';
import React from 'react';
import { getRawNumber } from 'utils/formatters';
import useUserDetails from '../../../../../../../hooks/requests/user/hooks/useUserDetails';

const SignUpVerify = ({
  goBack,
  onFinish,
  tenant,
}: Partial<FlowComponentProps>) => {
  const { email } = useSignUp();
  const { userDetails, initRequest } = useUserDetails();
  const { dateOfBirth, phoneNumber, fullName } = useSignUp();

  const onSignup = async () => {
    const options = {
      dateOfBirth: new Date(dateOfBirth),
      phoneNumber: getRawNumber(phoneNumber),
      fullName,
      doneOnBoarding: true,
      pushNotificationsEnabled: true,
    };
    await updateUserDetails(options);
    if (initRequest) {
      await initRequest;
      analytics.track(SIGN_UP_PROCESS_COMPLETE, userDetails);
    }
    onFinish?.();
  };

  return (
    <div className={classes.container}>
      {goBack && (
        <BackButtonIcon
          onClick={() => goBack()}
          className={classes.backButton}
        />
      )}
      <LoginSignupCodeVerify
        isEmail={true}
        identifier={email}
        onSuccess={onSignup}
        tenant={tenant ? tenant : false}
      />
    </div>
  );
};

export default SignUpVerify;
